import type { ConfirmDialogMessages } from 'containers/ConfirmDialog/ConfirmDialog';
import { produce } from 'immer';
import { FormattedMessage } from 'react-intl';

export const formatDeleteRowsConfirmDialogMessages = (
  messages: ConfirmDialogMessages,
  count: number,
): ConfirmDialogMessages =>
  produce<ConfirmDialogMessages>(messages, (draft) => {
    draft.header = (
      <FormattedMessage
        id='tableDeletionHelper.header'
        defaultMessage={draft.header as string}
        values={{ count }}
      />
    );
    draft.subHeader = (
      <FormattedMessage
        id='tableDeletionHelper.subHeader'
        defaultMessage={draft.subHeader as string}
        values={{ count }}
      />
    );
  });
